/**
 * Tabs Component.
 * For toggle tab; switch experience between personal, business and others
 * toggle labelArray data struture
 *  [{
 *    key,
 *    label,
 *    priority,
 *    href,
 *  }, ...]
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _toNumber from 'lodash/toNumber';

// Helper
import * as shape from '../../constants/PropTypesShapes';
import { trackLink } from '../../../lib/analytics-helper';

class Tabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: this.props.selected,
    };

    // binding this function
    this.renderLabel = this.renderLabel.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  // Handle Click event with Tracking FPTI as a Param.
  handleClick(e, index) {
    this.setState({
      selected: index.priority,
    });
    if (this.props.trackLink && this.props.trackLink.id && this.props.trackLink.link) {
      trackLink(this.props.trackLink);
    }
    if (this.props.onClick) {
      this.props.onClick(index);
    }
  }

  handleKeyPress(e, tab) {
    if (e.which === 13) {
      this.handleClick(e, tab);
    }
  }

  // Sort the display sequence by priority index
  sortTabNameList() {
    return this.props.labelArray.sort((tab1, tab2) => (
       _toNumber(tab1.priority) - _toNumber(tab2.priority)
    ));
  }

  // Add active for selection toggle
  renderActiveClass(index) {
    return (this.state.selected === index ? 'active ' : '') + this.props.tabClass;
  }

  // render Each content toggle
  renderLabel(tab, index) {
    const activeClass = this.renderActiveClass(index);
    let Tag = 'button';

    const tabAttribs = {
      id: `tab-linkContent__${tab.key}`,
      className: `btn vx_btn-link linkContent ${activeClass}`,
      onClick: e => this.handleClick(e, tab),
      onKeyPress: e => this.handleKeyPress(e, tab),
      tabIndex: 0,
      role: 'tab',
    };

    if (this.props.hashAnchor) {
      Tag = 'a';
      tabAttribs.name = `${tab.key}`;
      tabAttribs.href = `#${tab.key}`;
    }

    if (this.state.selected === index) {
      tabAttribs['aria-current'] = 'page';
    }

    return (
      <div key={index} className="tab" >
        <Tag {...tabAttribs}>
          {tab.label}
        </Tag>
      </div>
    );
  }

  // render content toggles with container
  renderTabs() {
    return (
      <div className="tabs-panel" role="tablist">
        {this.sortTabNameList().map(this.renderLabel)}
      </div>
    );
  }

  render() {
    return (
      <div className={this.props.className}>
        {this.renderTabs()}
      </div>
    );
  }
}

// Tabs Props Types.
Tabs.propTypes = {
  className: PropTypes.string,
  labelArray: PropTypes.arrayOf(PropTypes.shape(shape.TAB)).isRequired,
  onClick: PropTypes.func,
  trackLink: PropTypes.shape({
    id: PropTypes.string,
    link: PropTypes.string,
  }),
  selected: PropTypes.number,
  tabClass: PropTypes.string,
  hashAnchor: PropTypes.bool,
};

Tabs.defaultProps = {
  className: 'tabs-container',
  onClick: () => {},
  trackLink: {},
  selected: 0,
  tabClass: '',
  hashAnchor: false,
};

export default Tabs;
